import ContextConnectButton from '@/components/ContextCard/ContextConnectButton'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogPreviewHeader({ title, onOpen }) {
  return (
    <header className={styles.previewHeader}>
      <h3 className={styles.previewTitle}>{title}</h3>
      <ContextConnectButton
        type="button"
        hideIcon
        className={styles.previewOpenButton}
        onClick={onOpen}
      >
        Open
      </ContextConnectButton>
    </header>
  )
}
